import { api } from 'app/app.api';

import {
  CreateScheduledConversationsCsvApiArg,
  CreateScheduledConversationsCsvApiResponse,
  ReadOriginalEmailApiArg,
  ReadOriginalEmailApiResponse,
  ReadScheduledConversationsCsvApiArg,
  ReadScheduledConversationsCsvApiResponse,
} from './types/userContentApi.types';
import { transformReadOriginalEmail } from './utils/transformResponse';

export const userContentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    readOriginalEmail: builder.query<
      ReadOriginalEmailApiResponse,
      ReadOriginalEmailApiArg
    >({
      query: ({ path }) => ({
        path,
        type: 'userContent',
      }),
      transformResponse: transformReadOriginalEmail,
    }),
    readScheduledConversationsCsv: builder.query<
      ReadScheduledConversationsCsvApiResponse,
      ReadScheduledConversationsCsvApiArg
    >({
      query: ({ path }) => ({
        path,
        type: 'userContent',
      }),
    }),
    createScheduledConversationsCsv: builder.mutation<
      CreateScheduledConversationsCsvApiResponse,
      CreateScheduledConversationsCsvApiArg
    >({
      query: ({ file }) => {
        const body = new FormData();
        body.append('file', file);

        return {
          method: 'POST',
          contentType: 'multipart/form-data',
          path: '/private/scheduled_conversation_input/callback',
          type: 'files',
          body,
        };
      },
    }),
  }),
});
